import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import ErrorMessage_vue_vue_type_script_setup_true_lang_default from "./ErrorMessage.vue.script.js";
/* empty css                           */
//#region src/components/ErrorMessage.vue
var ErrorMessage_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ErrorMessage_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-130cb1d5"]]);
//#endregion
export { ErrorMessage_default as default };

//# sourceMappingURL=ErrorMessage.vue.js.map